var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "tap-top4",
    on: {
      "click": _vm.toggleChatPopup
    }
  }, [_c('img', {
    staticClass: "chatbot-logo",
    attrs: {
      "src": "img/chatbotlogo.svg",
      "alt": "chatbotLogo"
    }
  })]), _vm.showChatPopup ? _c('div', {
    staticClass: "chat-popup",
    class: {
      closing: _vm.isClosing
    }
  }, [_c('div', {
    staticClass: "chat-header"
  }, [_vm._m(0), _c('div', {
    staticClass: "close-button",
    on: {
      "click": _vm.toggleChatPopup
    }
  }, [_c('b-icon', {
    attrs: {
      "icon": "x-circle-fill"
    }
  })], 1)]), _c('div', {
    ref: "chatMessages",
    staticClass: "chat-messages"
  }, [_vm._l(_vm.messages, function (message) {
    var _message$accountDetai, _message$orderDetailD, _message$orderDetailD2, _message$orderDetailD3, _message$orderDetailD4, _message$orderDetailD5, _message$orderDetailD6, _message$orderDetailD7, _message$orderDetailD8, _message$orderDetailD9, _message$orderDetailD0, _message$orderDetailD1, _message$orderDetailD10, _message$orderDetailD11, _message$buttons;
    return _c('div', {
      key: message.id,
      staticClass: "message",
      class: message.sender
    }, [_c('div', {
      staticClass: "img"
    }, [_c('img', {
      staticClass: "avatar",
      attrs: {
        "src": message.sender === 'bot' ? 'img/chatbotlogo.svg' : _vm.userImage,
        "alt": "avatar"
      }
    })]), _c('div', {
      staticClass: "bubble"
    }, [message.accountDetailData ? [_c('div', {
      staticClass: "account-detail-container"
    }, [_c('h4', [_vm._v("Account Details")]), message.accountDetailMessage ? _c('p', [_vm._v(" " + _vm._s(message.accountDetailMessage) + " ")]) : _vm._e(), _c('ul', [_c('li', [_c('strong', [_vm._v("Name:")]), _vm._v(" " + _vm._s(message.accountDetailData.name.first) + " " + _vm._s(message.accountDetailData.name.last) + " ")]), _c('li', [_c('strong', [_vm._v("Email:")]), _vm._v(" " + _vm._s(message.accountDetailData.authentication.email) + " ")]), _c('li', [_c('strong', [_vm._v("Phone:")]), _vm._v(" " + _vm._s(message.accountDetailData.authentication.phone) + " ")]), _c('li', [_c('strong', [_vm._v("Category:")]), _vm._v(" " + _vm._s(message.accountDetailData.category) + " ")]), (_message$accountDetai = message.accountDetailData.addresses) !== null && _message$accountDetai !== void 0 && _message$accountDetai.length ? _c('li', [_c('strong', [_vm._v("Addresses:")]), _c('ul', _vm._l(message.accountDetailData.addresses, function (address) {
      return _c('li', {
        key: address._id
      }, [_vm._v(" " + _vm._s(address.city) + ", " + _vm._s(address.state) + ", " + _vm._s(address.street1) + ", " + _vm._s(address.street2) + ", " + _vm._s(address.zip) + " ")]);
    }), 0)]) : _vm._e()])])] : _vm._e(), message.orderTableData ? [_c('div', {
      staticClass: "order-table-container"
    }, [_c('h4', [_vm._v(_vm._s(message.orderTableTitle))]), message.orderTableMessage ? _c('p', [_vm._v(" " + _vm._s(message.orderTableMessage) + " ")]) : _vm._e(), _c('table', {
      staticClass: "order-table"
    }, [_vm._m(1, true), _c('tbody', _vm._l(message.orderTableData, function (item) {
      return _c('tr', {
        key: item._id,
        staticClass: "order-row",
        on: {
          "click": function ($event) {
            return _vm.handleOrderRowClick(item, message.scenarioType);
          }
        }
      }, [_c('td', [_vm._v(_vm._s(item.name))]), _c('td', [_vm._v(_vm._s(_vm.currency.symbol) + _vm._s(item.price))]), _c('td', [_vm._v(_vm._s(item.orderStatus))]), _c('td', [_vm._v(_vm._s(item.orderId.toString().substring(0, 5)) + "...")])]);
    }), 0)])])] : _vm._e(), message.paymentIssueForm ? [_c('div', {
      staticClass: "contact-form-container"
    }, [_c('form', {
      on: {
        "submit": function ($event) {
          $event.preventDefault();
          return _vm.submitPaymentIssueForm.apply(null, arguments);
        }
      }
    }, [_c('div', [_c('label', [_vm._v("Message/Query:")]), _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.paymentIssueForm.message,
        expression: "paymentIssueForm.message"
      }],
      attrs: {
        "required": ""
      },
      domProps: {
        "value": _vm.paymentIssueForm.message
      },
      on: {
        "input": function ($event) {
          if ($event.target.composing) return;
          _vm.$set(_vm.paymentIssueForm, "message", $event.target.value);
        }
      }
    })]), _c('button', {
      attrs: {
        "type": "submit"
      }
    }, [_vm._v("Submit")])])])] : _vm._e(), message.orderNotFoundForm ? [_c('div', {
      staticClass: "contact-form-container"
    }, [_c('form', {
      on: {
        "submit": function ($event) {
          $event.preventDefault();
          return _vm.submitOrderNotFoundForm.apply(null, arguments);
        }
      }
    }, [_c('div', [_c('label', [_vm._v("Message/Query:")]), _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.paymentIssueForm.message,
        expression: "paymentIssueForm.message"
      }],
      attrs: {
        "required": ""
      },
      domProps: {
        "value": _vm.paymentIssueForm.message
      },
      on: {
        "input": function ($event) {
          if ($event.target.composing) return;
          _vm.$set(_vm.paymentIssueForm, "message", $event.target.value);
        }
      }
    })]), _c('button', {
      attrs: {
        "type": "submit"
      }
    }, [_vm._v("Submit")])])])] : _vm._e(), message.reportIssueForm ? [_c('div', {
      staticClass: "bot-message contact-form-container"
    }, [_c('form', {
      on: {
        "submit": function ($event) {
          $event.preventDefault();
          return _vm.submitReportIssueForm.apply(null, arguments);
        }
      }
    }, [_c('div', [_c('label', [_vm._v("Message/Query:")]), _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.reportIssueForm.message,
        expression: "reportIssueForm.message"
      }],
      attrs: {
        "required": ""
      },
      domProps: {
        "value": _vm.reportIssueForm.message
      },
      on: {
        "input": function ($event) {
          if ($event.target.composing) return;
          _vm.$set(_vm.reportIssueForm, "message", $event.target.value);
        }
      }
    })]), _c('button', {
      attrs: {
        "type": "submit"
      }
    }, [_vm._v("Submit")])])])] : _vm._e(), message.delivaryIssueForm ? [_c('div', {
      staticClass: "bot-message contact-form-container"
    }, [_c('form', {
      on: {
        "submit": function ($event) {
          $event.preventDefault();
          return _vm.submitDelivaryIssueForm.apply(null, arguments);
        }
      }
    }, [_c('div', [_c('label', [_vm._v("Message/Query:")]), _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.delivaryIssueForm.message,
        expression: "delivaryIssueForm.message"
      }],
      attrs: {
        "required": ""
      },
      domProps: {
        "value": _vm.delivaryIssueForm.message
      },
      on: {
        "input": function ($event) {
          if ($event.target.composing) return;
          _vm.$set(_vm.delivaryIssueForm, "message", $event.target.value);
        }
      }
    })]), _c('button', {
      attrs: {
        "type": "submit"
      }
    }, [_vm._v("Submit")])])])] : _vm._e(), message.orderDetailData ? [_c('div', {
      staticClass: "order-detail-container"
    }, [_c('h4', [_vm._v(_vm._s(message.orderDetailTitle))]), message.orderDetailMessage ? _c('p', [_vm._v(" " + _vm._s(message.orderDetailMessage) + " ")]) : _vm._e(), _c('ul', [_c('li', [_c('strong', [_vm._v("Order ID:")]), _vm._v(" " + _vm._s(message.orderDetailData.orderId) + " ")]), _c('li', [_c('strong', [_vm._v("Item Name:")]), (_message$orderDetailD = message.orderDetailData.items) !== null && _message$orderDetailD !== void 0 && _message$orderDetailD[0] ? _c('span', [_vm._v(" " + _vm._s(message.orderDetailData.items[0].name) + " ")]) : _vm._e()]), _c('li', [_c('strong', [_vm._v("Provider:")]), (_message$orderDetailD2 = message.orderDetailData.items) !== null && _message$orderDetailD2 !== void 0 && _message$orderDetailD2[0] ? _c('span', [_vm._v(" " + _vm._s(message.orderDetailData.items[0].providerName) + " ")]) : _vm._e()]), _c('li', [_c('strong', [_vm._v("Price:")]), (_message$orderDetailD3 = message.orderDetailData.items) !== null && _message$orderDetailD3 !== void 0 && _message$orderDetailD3[0] ? _c('span', [_vm._v(" " + _vm._s(_vm.currency.symbol) + _vm._s(message.orderDetailData.items[0].price) + " ")]) : _vm._e()]), message.orderDetailData.orderStatus ? _c('li', [_c('strong', [_vm._v("Order Status:")]), _vm._v(" " + _vm._s(message.orderDetailData.orderStatus) + " ")]) : _vm._e(), _c('li', [_c('strong', [_vm._v("Payment Type:")]), _vm._v(" " + _vm._s(message.orderDetailData.paymentType) + " ")]), ((_message$orderDetailD4 = message.orderDetailData.items[0].delivery) === null || _message$orderDetailD4 === void 0 ? void 0 : _message$orderDetailD4.courier_name) !== 'self' && message.orderDetailData.deliveryAddress ? _c('li', [_c('strong', [_vm._v("Delivery Address:")]), _vm._v(" " + _vm._s((_message$orderDetailD5 = message.orderDetailData.deliveryAddress.address) === null || _message$orderDetailD5 === void 0 ? void 0 : _message$orderDetailD5.houseNumber) + ", " + _vm._s((_message$orderDetailD6 = message.orderDetailData.deliveryAddress.address) === null || _message$orderDetailD6 === void 0 ? void 0 : _message$orderDetailD6.street1) + ", "), (_message$orderDetailD7 = message.orderDetailData.deliveryAddress.address) !== null && _message$orderDetailD7 !== void 0 && _message$orderDetailD7.street2 ? [_vm._v(" " + _vm._s(message.orderDetailData.deliveryAddress.address.street2) + ", ")] : _vm._e(), _vm._v(" " + _vm._s((_message$orderDetailD8 = message.orderDetailData.deliveryAddress.address) === null || _message$orderDetailD8 === void 0 ? void 0 : _message$orderDetailD8.city) + ", " + _vm._s((_message$orderDetailD9 = message.orderDetailData.deliveryAddress.address) === null || _message$orderDetailD9 === void 0 ? void 0 : _message$orderDetailD9.state) + ", " + _vm._s((_message$orderDetailD0 = message.orderDetailData.deliveryAddress.address) === null || _message$orderDetailD0 === void 0 ? void 0 : _message$orderDetailD0.zip) + " ")], 2) : ((_message$orderDetailD1 = message.orderDetailData.items[0].delivery) === null || _message$orderDetailD1 === void 0 ? void 0 : _message$orderDetailD1.courier_name) === 'self' ? _c('li', [_c('strong', [_vm._v("Delivery Address:")]), _vm._v(" This is a self-pickup order. ")]) : _vm._e(), (_message$orderDetailD10 = message.orderDetailData.items) !== null && _message$orderDetailD10 !== void 0 && (_message$orderDetailD11 = _message$orderDetailD10[0]) !== null && _message$orderDetailD11 !== void 0 && _message$orderDetailD11.imageLink ? _c('li', [_c('img', {
      staticClass: "product-image",
      attrs: {
        "src": message.orderDetailData.items[0].imageLink,
        "alt": "Product"
      }
    })]) : _vm._e()])])] : _vm._e(), message.contactForm ? [_c('div', {
      staticClass: "contact-form-container"
    }, [_c('form', {
      on: {
        "submit": function ($event) {
          $event.preventDefault();
          return _vm.submitContactForm.apply(null, arguments);
        }
      }
    }, [_c('div', [_c('label', [_vm._v("Message/Query:")]), _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.contactForm.message,
        expression: "contactForm.message"
      }],
      attrs: {
        "required": ""
      },
      domProps: {
        "value": _vm.contactForm.message
      },
      on: {
        "input": function ($event) {
          if ($event.target.composing) return;
          _vm.$set(_vm.contactForm, "message", $event.target.value);
        }
      }
    })]), _c('button', {
      attrs: {
        "type": "submit"
      }
    }, [_vm._v("Submit")])])])] : _vm._e(), _c('div', {
      staticClass: "msg",
      domProps: {
        "innerHTML": _vm._s(_vm.getHtml(message.text))
      }
    }), (_message$buttons = message.buttons) !== null && _message$buttons !== void 0 && _message$buttons.length ? _c('div', {
      staticClass: "button-list"
    }, _vm._l(message.buttons, function (button) {
      return _c('button', {
        key: button.payload,
        staticClass: "response-button",
        on: {
          "click": function ($event) {
            return _vm.handleButtonClick(button.payload);
          }
        }
      }, [_vm._v(" " + _vm._s(button.title) + " ")]);
    }), 0) : _vm._e()], 2)]);
  }), _vm.isTyping ? _c('div', {
    staticClass: "message bot"
  }, [_vm._m(2)]) : _vm._e()], 2)]) : _vm._e()]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "chat-title"
  }, [_c('img', {
    staticClass: "chatbot-logo-small",
    attrs: {
      "src": "img/chatbotlogo.svg",
      "alt": "chatbotLogo"
    }
  }), _c('span', [_vm._v("Chatbot")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('thead', [_c('tr', [_c('th', [_vm._v("Item Name")]), _c('th', [_vm._v("Price")]), _c('th', [_vm._v("Status")]), _c('th', [_vm._v("Order Id")])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "bubble typing-indicator"
  }, [_c('div', {
    staticClass: "dot"
  }), _c('div', {
    staticClass: "dot"
  }), _c('div', {
    staticClass: "dot"
  })]);

}]

export { render, staticRenderFns }